const short = require("short-uuid");
const baseModel = require("../baseModel")
// カスタマイズレコード用sk
const sk = "customize";

/**
 * カスタマイズレコード用のデータ取得モデルクラス
 */
class CustomizeModel extends baseModel {
  /**
   *
   * @param {テナント} tenantId
   * @returns
   */
  static async getCustomizeList(tenantId) {
    return await this.filterNotDeleteList(
      await super.getList({ beginsWith: this.createGetSk() }, tenantId)
    );
  }

  /**
   * 削除データ以外を取得する
   * @param {array} results テナントカスタマイズレコードリスト
   * @returns 削除データ以外のリスト
   */
  static async filterNotDeleteList(results) {
    return results.filter(function(item) {
      // console.log(item)
      if (!item._deleted) {
        // deleteFlgが未定義 -> 表示対象
        return item;
      }
      if (item._deleted !== true) {
        // deleteFlgがfalse -> 表示対象
        return item;
      }
    });
  }

  /**
   * カスタマイズレコードを削除する
   * @param {pk:テナントID, sk:sk} data
   * @returns
   */
  static async deleteCustomize(data) {
    await super.deleteData(data);
  }

  /**
   * カスタマイズレコードを追加する
   * @param {*} data
   */
  static async addCustomize(data) {
    let result = await super.addData(data);
    console.log(`addCustomize ${JSON.stringify(result)}`);
  }

  /**
   * カスタマイズレコードを更新する
   * @param {*} data
   */
  static async updateCustomize() {
    await super.updateData(data);
  }

  /**
   * カスタマイズレコードを取得する
   * @param {*} data
   */
  static async getCustomize(tenantId) {
    return await super.getSingleData({sk: sk}, tenantId);
  }

  /**
   * 取得用skの文字列を生成
   * @returns {取得用skの文字列}
   */
  static createGetSk() {
    return sk;
  }

  /**
   * skの文字列を生成
   * @returns
   */
  static createSk() {
    return sk;
  }

  /**
   * 新規登録用のスキーマ
   */
  static async getNewData() {
    let newRowData = await super.getNewData();

    const id = short.generate();
    newRowData.sk = this.createSk();

    newRowData.customize = {
      key: "",
      memo: ""
    };

    return newRowData;
  }
}

module.exports = CustomizeModel;
